import { type UserAddress } from "@/schemas/location/address";
import { type UserLocation } from "@/schemas/location/user_location";

export function formatAddress(address: UserAddress | null): string {
  if (address === null) {
    return "Not Available";
  }

  const { city, state, country, countryCode } = address;

  let formattedAddress = "";

  // Add city if available
  if (city) {
    formattedAddress += city;
  }

  // Add state if city is not available
  if (!city && state) {
    formattedAddress += state;
  }

  // Add country if it's not US and we have either city or state
  if (countryCode !== "USA" && formattedAddress) {
    formattedAddress += `, ${country}`;
  }

  // If we don't have city or state, just use country
  if (!formattedAddress && country) {
    formattedAddress = country;
  }

  return formattedAddress || "Not available";
}

export function formatSecondaryAddress(address: UserAddress | null): string {
  if (address === null) {
    return "Not Available";
  }

  const { city, state, street } = address;

  let formattedAddress = "";

  // Add street if available
  if (street) {
    formattedAddress += street;
  }

  // Add city if available
  if (city) {
    formattedAddress += formattedAddress ? `, ${city}` : city;
  }

  // Add state if available
  if (state) {
    formattedAddress += formattedAddress ? `, ${state}` : state;
  }

  return formattedAddress || "Not available";
}

export function formatLocationAddress(location: UserLocation | null): string {
  if (location === null) {
    return "Not available.";
  } else {
    return formatAddress(location.address);
  }
}
